skrilla.controller('totpModalCtrl', function ($scope, searchService, $window, $location, adminService, modalService, $http, envService) {
  $scope.createTotp = function () {
    $http.post(envService.read('loginUrl') + "totp", {}).then(function(response){
      $scope.url = response.data.url;
    }, function(response){
      console.log(response);
      swal("Error!", response.data.message)
    });
  };

  $scope.createTotp();


  $scope.close = function () {
    modalService.dismissAll()
  };

  $scope.confirmTotp = function () {
        console.log($scope.totpDetails)

        var existingToken = $window.localStorage.token
        var basic = btoa(adminService.getAdmin().email + ":"  + $scope.totpDetails.password)
        var tempToken =  existingToken + " Basic " + basic
        $window.localStorage.token = tempToken

        $http.put(envService.read('loginUrl') + "totp", {"otp":  $scope.totpDetails.otp}).then(function(response){
          $window.localStorage.token = existingToken
          if (response.status == 200 || response.status == 204) {
            modalService.dismissAll();
          }
        }, function(response) {
          $window.localStorage.token = existingToken
          console.log(response)
          swal("Error!", response.data.errors[0].message)
        });
    }
  $scope.btnPress = function (keyEvent) {
        if (keyEvent.which === 13)
            $scope.confirmTotp();
  }
});

